import { Config } from "./Controller/3DController/ConfiguratorModel";
import { getWhiteLabel } from "./whitelabel";

export interface IURLData {
  highlightAR:boolean;
  previewEventName:string;
  futbol:boolean;
  config?:Config;
}

const urlData:IURLData = {
  highlightAR: false,
  previewEventName: undefined,
  futbol: false
};

export function initUrlData() {
  const urlParams = new URLSearchParams(window.location.search);
  const urlConfig = urlParams.get("config");
  const modelName = window.location.hash.replace('#', '');

  // special case: #futbol link enables the soccer event and loads the default car.
  /*if (modelName == 'futbol') {
    urlData.futbol = true;
  
    urlData.config = {
      model: getWhiteLabel().defaultCar,
      options: {},
      ambilightIntensity: 0
    };

    urlData.previewEventName = 'soccer';
  }*/

  if (urlConfig) {
    urlData.config = JSON.parse(atob(urlConfig));
  } else if (!urlData.futbol && modelName.length != 0) {
    urlData.config = {
      model: modelName,
      options: {},
      ambilightIntensity: 0
    };
    window.location.hash = '';
  }

  urlData.highlightAR = urlParams.has("highlight-ar");
  if (!urlData.previewEventName) {
    urlData.previewEventName = urlParams.get("vw-preview-event");
  }
}

export function getUrlData() {
  return urlData;
}

export function buildUrl(config:Config, highlightAR:boolean = false):string {
  let url = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${window.location.pathname}`;

  url += `?config=${btoa(JSON.stringify(config))}`;

  if (highlightAR) {
    url += `&highlight-ar`;
  }

  if (urlData.futbol) {
    url += `#futbol`;
  }

  return url;
}